module.exports = __webpack_public_path__ + "assets/img/image07.e3e75b71.png";